import React from 'react'
import RadioInput from '../../../components/inputs/RadioInput'
import StringInput from '../../../components/inputs/StringInput'
import NumberInput from '../../../components/inputs/NumberInput'
import { NewContract } from '@vae/server/dist/client'
import { useTranslation } from 'react-i18next'

const BillingAddressDetailsStep: React.FC<{
	seperateBillingAddress: boolean
	setSeperateBillingAddress: any
	contract: Partial<NewContract>
	setContract: React.Dispatch<React.SetStateAction<Partial<NewContract>>>
}> = ({ seperateBillingAddress, setSeperateBillingAddress, contract, setContract }) => {
	const { t } = useTranslation('modals_createContract', { keyPrefix: 'billingAdressDetailsStep' })

	return (
		<div className='container'>
			<RadioInput
				isChecked={!seperateBillingAddress}
				onChange={() => setSeperateBillingAddress(false)}
				label={t('sameBillingAddress')}
			/>
			<RadioInput
				isChecked={seperateBillingAddress}
				onChange={() => setSeperateBillingAddress(true)}
				label={t('seperateBillingAddress')}
			/>

			{seperateBillingAddress && (
				<>
					<StringInput
						value={contract?.invoicestreetAddress ?? ''}
						label={t('street')}
						onChange={v => setContract(prev => ({ ...prev, invoicestreetAddress: v }))}
					/>
					<NumberInput
						value={contract?.invoicehouseNumber ?? ''}
						label={t('houseNumber')}
						onChange={v => setContract(prev => ({ ...prev, invoicehouseNumber: v }))}
					/>
					<StringInput
						value={contract?.invoicestairwellIdentification ?? ''}
						label={t('stairwell')}
						onChange={v => setContract(prev => ({ ...prev, invoicestairwellIdentification: v }))}
					/>
					<StringInput
						value={contract?.invoiceapartment ?? ''}
						label={t('apartment')}
						onChange={v => setContract(prev => ({ ...prev, invoiceapartment: v }))}
					/>
					<StringInput
						value={contract?.invoicecity ?? ''}
						label={t('city')}
						onChange={v => setContract(prev => ({ ...prev, invoicecity: v }))}
					/>
					<NumberInput
						value={contract?.invoicezipCode ?? ''}
						label={t('zipCode')}
						onChange={v => setContract(prev => ({ ...prev, invoicezipCode: v }))}
					/>
				</>
			)}
		</div>
	)
}

export default BillingAddressDetailsStep
